import { AdditionalParams, createRequest, Data, platform } from "@shared/platform-api/requests"
import { createRequestHook } from "../../createRequestHook"
import { TripVehicle, TripVehicleSortKeys } from "./types"
import { fromApi } from "./utils"
import { isNewPipelinePolicy } from "../../../utils"

export type SearchTripVehiclesBaseInput = Readonly<{
  minimumDistanceDriven?: number
  policyId: string
}>
export type SearchTripVehiclesInput = SearchTripVehiclesBaseInput & AdditionalParams<TripVehicleSortKeys>
type Output = Data<TripVehicle>

const searchVehicles = createRequest<SearchTripVehiclesInput, Output>(
  async (input: SearchTripVehiclesInput, getToken): Promise<Output> => {
    const useNewPipeline = isNewPipelinePolicy(input.policyId)
    const result = await platform(getToken).trips.searchVehicles({
      ...input,
      ...(useNewPipeline ? { dbName: `athena` } : {}),
    })

    return {
      ...result,
      items: result.items.map((vehicle) => fromApi(vehicle)),
    }
  }
)

export const useSearchTripVehicles = createRequestHook<SearchTripVehiclesInput, Output, TripVehicleSortKeys>(
  searchVehicles
)
